module.exports = __webpack_public_path__ + "images/home/product/features-files-610ba5d3935eb199b7e0c376ff0229c1.png";